import { Box, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CasinoIcon from '@mui/icons-material/Casino';
import { useTranslation } from 'react-i18next';

const AddGameCard = ({ onClick, empty = false }) => {
  const { t } = useTranslation();

  return (
    <Stack
      component="button"
      type="button"
      spacing={1}
      onClick={onClick}
      aria-label={t('shelf.addCard.ariaLabel')}
      sx={{
        p: 0,
        border: 0,
        textAlign: 'left',
        bgcolor: 'transparent',
        cursor: 'pointer',
        font: 'inherit',
        minWidth: 0,
        '&:hover .add-game-cover, &:focus-visible .add-game-cover': {
          borderColor: 'primary.main',
          boxShadow: 3,
          transform: 'translateY(-4px)',
        },
        '&:focus-visible': {
          outline: '3px solid',
          outlineColor: 'secondary.light',
          outlineOffset: 4,
          borderRadius: 2,
        },
      }}
    >
      <Box
        className="add-game-cover"
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '3 / 4',
          overflow: 'hidden',
          border: '2px dashed',
          borderColor: empty ? 'secondary.main' : 'secondary.light',
          borderRadius: 2,
          color: 'primary.main',
          background:
            'linear-gradient(155deg, rgba(255,250,239,0.98) 0%, rgba(233,221,196,0.92) 100%)',
          boxShadow: '0 14px 24px -20px rgba(45, 26, 11, 0.62)',
          transition:
            'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
          display: 'grid',
          placeItems: 'center',
          p: { xs: 1.5, sm: 2 },
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 10,
            border: '1px solid',
            borderColor: 'rgba(15, 76, 69, 0.12)',
            borderRadius: 1.25,
          },
        }}
      >
        <Stack alignItems="center" sx={{ position: 'relative', textAlign: 'center' }}>
          <Box
            data-testid="add-game-card-main-icon"
            sx={{
              position: 'relative',
              width: { xs: 64, sm: 74 },
              height: { xs: 64, sm: 74 },
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              bgcolor: 'rgba(15, 76, 69, 0.1)',
              color: 'primary.main',
              border: '1px solid rgba(15, 76, 69, 0.18)',
              boxShadow: '0 12px 24px -18px rgba(6, 37, 34, 0.82)',
            }}
          >
            <CasinoIcon sx={{ fontSize: { xs: 34, sm: 40 } }} />
            <Box
              data-testid="add-game-card-plus-badge"
              sx={{
                position: 'absolute',
                right: -4,
                bottom: -4,
                width: { xs: 30, sm: 34 },
                height: { xs: 30, sm: 34 },
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                border: '2px solid',
                borderColor: 'background.paper',
                boxShadow: '0 10px 18px -14px rgba(6, 37, 34, 0.82)',
              }}
            >
              <AddIcon sx={{ fontSize: { xs: 19, sm: 22 } }} />
            </Box>
          </Box>
        </Stack>
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" noWrap>
          {t('shelf.addCard.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {empty ? t('shelf.addCard.emptySubtitle') : t('shelf.addCard.subtitle')}
        </Typography>
      </Box>
    </Stack>
  );
};

export default AddGameCard;
